'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _moment = _interopRequireDefault(require("moment"));
var _reactDatePicker = _interopRequireDefault(require("react-date-picker"));
var _FormHelperText = _interopRequireDefault(require("@material-ui/core/FormHelperText"));
var _InputLabel = _interopRequireDefault(require("@material-ui/core/InputLabel"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
let app = window.app;
class DateInput extends _react.Component {
  state = {
    id: ++app.form_index
  };

  /**
   * @param    { Object }     date     moment date
   **/
  handleChange = date => {
    const component = this,
      props = this.props,
      state = this.state;
    props.onChange({
      value: (0, _moment.default)(date).format(),
      name: props.name
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    let error_msg,
      status = props.status[props.name];
    if (status && status.error) {
      error_msg = /*#__PURE__*/_react.default.createElement(_FormHelperText.default, {
        error: true
      }, status.error);
    }
    let value = ''; // defaults to cleared date

    if (!['undefined', undefined, ''].includes(props.value)) {
      value = _moment.default.isMoment(props.value) ? props.value : (0, _moment.default)(props.value);
      value = value.toDate();
      const dateConversionFailed = isNaN(value.getTime());
      const clearingDateValue = '';
      if (dateConversionFailed) value = clearingDateValue;
    }
    let output = /*#__PURE__*/_react.default.createElement("div", {
      className: 'u-positioned ' + (props.className || (props.full_width ? 'u-full-width' : ''))
    }, /*#__PURE__*/_react.default.createElement(_InputLabel.default, {
      htmlFor: String(state.id),
      style: {
        marginTop: '15px',
        marginBottom: '8px',
        display: 'block'
      }
    }, props.label), /*#__PURE__*/_react.default.createElement(_reactDatePicker.default, {
      id: String(state.id),
      className: "customCalendarInput",
      onChange: component.handleChange,
      calendarIcon: null,
      isClearable: true,
      isOpen: props.calendarOpen,
      disabled: props.disabled,
      locale: props.locale,
      value: value
    }), error_msg);
    return output;
  }
}
exports.default = DateInput;
DateInput.propTypes = {
  onChange: _propTypes.default.func,
  full_width: _propTypes.default.bool,
  allow_no_value: _propTypes.default.bool,
  className: _propTypes.default.string,
  label: _propTypes.default.string,
  buttonClassName: _propTypes.default.string,
  name: _propTypes.default.string.isRequired,
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
  calendarIcon: _propTypes.default.bool,
  clearIcon: _propTypes.default.bool,
  isOpen: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  locale: _propTypes.default.string,
  status: _propTypes.default.object
};
DateInput.defaultProps = {
  full_width: true,
  calendarIcon: true,
  clearIcon: true,
  isOpen: true,
  disabled: false,
  locale: 'fr',
  status: {}
};
